export const Envs = {
  BFF_WEB_URL: process.env['NX_BFF_WEB_URL'] ?? process.env['REACT_APP_HUB_API'],
  APP_URL: process.env['NEXT_PUBLIC_APP_URL'] ?? process.env['REACT_APP_APP_URL'] ?? process.env['NX_APP_URL'],
  SITE_URL: process.env['NX_SITE_URL'] ?? process.env['NEXT_PUBLIC_SITE_URL'] ?? process.env['REACT_APP_SITE_URL'],
  BFF_PRODUCT_URL: process.env['NX_BFF_PRODUCT_URL'] ?? process.env['REACT_APP_BFF_PRODUCT_URL'],
}
